import getData from './getData'
export const getDataService = getData;